import { Box } from '@mui/material'
import MainMenu from '../MainMenu'
import Logo from '../Logo'
import SubMenu from '../SubMenu';
import SocialLinks from './SocialLinks';
const SideBar = ({ isMobile }) => {

    if (isMobile) {
        return null;
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            flexGrow={1}
            justifyContent="space-between"
            gap={2}
            borderRadius={2}
            backgroundColor="background.paper"
            overflow="scroll"
            p={2}
            maxWidth='250px'
            minWidth='250px'
        >
            <Box
                display="flex"
                flexDirection="column"
                gap={3}
            >
                <Logo />
                <MainMenu isMobile={isMobile} />
            </Box>

            <Box
                display="flex"
                flexDirection="column"
                gap={3}
            >
                <SubMenu />
                <SocialLinks />
            </Box>


        </Box>
    );
}




export default SideBar;